<template>
    <div class="flex w-full my-account">
        <div :class="{ 'nav-sidebar': true, 'is-expanded': isSidebarExpanded }">
            <Sidebar />
        </div>
        <div class="main">
            <router-view></router-view>
        </div>
        <div class="right-sidebar">
            <BetSlipContainer/>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import BetSlipContainer from '@modules/sportOffer/betSlip/BetSlipContainer.vue';
    import Sidebar from '@modules/userProfile/Sidebar.vue';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';

    export default {
        name: 'ProfilePage',
        components: {
            BetSlipContainer,
            Sidebar,
        },
        computed: {
            ...mapGetters('ui/mobile', ['isSidebarOpen']),
            isSidebarExpanded() {
                return this.isSidebarOpen(SidebarId.accountPageNav);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/ProfilePage.vue